module.exports = __webpack_public_path__ + "img/anquan2-3.a26c6ce5.jpg";